var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-system-bar',{attrs:{"status":"","absolute":"","flat":"","dark":"","color":"primary"}},[_c('span',[_vm._v(" ©"+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("DINAMO Networks")])]),_c('v-spacer'),(_vm.version)?[_c('span',{staticClass:"ml-2"},[_vm._v(" "+_vm._s(_vm.version)+" ")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }